// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_ROLE, DELETE_ROLE, GET_DETAIL_ROLE, GET_LIST_ROLE, UPDATE_ROLE } from '~/utils/constants/actionType';
import { IFormRole } from '~/utils/interface/role';
import roleApi from '~/apis/role';
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';

export const getListRole = createAsyncThunk(GET_LIST_ROLE, async (params: IQueryParamBase, { rejectWithValue }) => {
  try {
    const resp = await roleApi.getListRole(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailRole = createAsyncThunk(GET_DETAIL_ROLE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await roleApi.getDetailRole(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createRole = createAsyncThunk(CREATE_ROLE, async (body: IFormRole, { rejectWithValue }) => {
  try {
    const resp = await roleApi.createRole(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateRole = createAsyncThunk(UPDATE_ROLE, async (params: IBodyUpdate<IFormRole>, { rejectWithValue }) => {
  try {
    const resp = await roleApi.updateRole(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteRole = createAsyncThunk(DELETE_ROLE, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await roleApi.deleteRole(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
